<template>
  <div id="app">
    <Integrated />
  </div>
</template>

<script>
import Integrated from './components/Integrated.vue'

export default {
  name: 'App',
  components: {
    Integrated
  }
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}
</style>
